import React, { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { Button, Col, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import MakePaymentService from "../../../../service/billing/payment/makePaymentService"
import { TPaymentSiharaiSimePostReq } from "../../../../service/billing/payment/TPayment"
import util from "../../../../ts/util"
import pageHelper from "../../../../ts/helpers/pageHelper"

// Kairos
import { AppDispatch } from "../../../.."
import { setAlerts } from "../../../../globalStore/alertStore"
import { showInfoToast } from "../../../../components/CustomToast"
import Spinner from "../../../../components/Spinner"

const MakeInvoiceExecModal: React.FC<
  TModalTypes & {
    支払年月?: string | null
    支払先コード?: string[] | null
    isExecSime: boolean
    setIsExecSime: (value: boolean) => unknown
  }
> = (props) => {
  const history = useHistory()
  const location = useLocation()

  const [isSearching, setIsSearching] = useState(false)

  //#region [method]
  /*
   * 支払締め処理
   * @param siharaiSimeCondition 支払締め処理実行条件
   */
  const siharaiSime = async (
    siharaiSimeCondition?: TPaymentSiharaiSimePostReq
  ) => {
    let currentSiharaiSimeCondition: TPaymentSiharaiSimePostReq
    // 実行条件生成
    if (siharaiSimeCondition) {
      // 引数の実行条件を使用
      currentSiharaiSimeCondition = siharaiSimeCondition
    } else {
      // stateから実行条件を生成
      currentSiharaiSimeCondition = createSiharaiSimeCondition()
    }
    // QueryStringに実行条件を反映
    pageHelper.pushQuery(history, location, currentSiharaiSimeCondition)

    try {
      await new MakePaymentService().siharaiSime(currentSiharaiSimeCondition)
      showInfoToast(`支払締め処理が完了しました`)
    } catch (error) {
      dispatch(setAlerts(error))
      throw error
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 支払締め処理実行条件オブジェクトを生成
   */
  const createSiharaiSimeCondition = (): TPaymentSiharaiSimePostReq => {
    return {
      支払年月: props.支払年月 ?? undefined,
      支払先コード: props.支払先コード?.slice() ?? undefined,
      支払先区分コード: "1" /* 1:傭車先 */,
    }
  }
  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [state]

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title}
      setIsShow={props.setIsShow}
      isDisabledCloseButton={isSearching}
      size={props.size}>
      <Spinner searching={isSearching} inModal={true}></Spinner>
      <div>
        {util.date.format(props.支払年月, "YYYY/MM")}{" "}
        　支払締め処理を実行します。
      </div>
      <Row className="search-button">
        <Col className="text-center">
          <Button
            className="w-9rem"
            variant="waiting"
            type="submit"
            onClick={async (e) => {
              e.stopPropagation()
              e.preventDefault()
              setIsSearching(true)
              try {
                await siharaiSime()
                props.setIsExecSime(true)
              } finally {
                props.setIsShow(false)
              }
            }}>
            実行
          </Button>
        </Col>
      </Row>
    </ModalOuter>
  )
}

export default MakeInvoiceExecModal
